import axios from 'axios';

const raw = axios.create({ baseURL: '/api', timeout: 30000 });

export async function requestPasswordReset(email: string): Promise<void> {
  await raw.post('/auth/password/reset/request', { email });
}

export async function completePasswordReset(
  userId: string,
  code: string,
  newPassword: string
): Promise<void> {
  await raw.post('/auth/password/reset/complete', {
    user_id: userId,
    code,
    new_password: newPassword
  });
}

export async function completeSetup(
  userId: string,
  inviteCode: string,
  newPassword: string,
  firstName?: string,
  lastName?: string
): Promise<void> {
  await raw.post('/auth/setup/complete', {
    user_id: userId,
    invite_code: inviteCode,
    new_password: newPassword,
    first_name: firstName,
    last_name: lastName
  });
}
